import { Flex } from "@chakra-ui/react";
import React from "react";
import { useParams } from "react-router-dom";

import { LoadingIndicator } from "../../../components";
import {
  CallType,
  useAuditLogItemExistsLazyQuery,
  useCallTypeQuery,
} from "../../graphql";
import { AiInterviewDetails } from "../AiInterviewDetails";
import CallErrorState from "./CallErrorState";
import InterviewDetails, { InterviewDetailsProps } from "./InterviewDetails";

type InterviewDetailsWrapperProps = Omit<InterviewDetailsProps, "callId">;

const InterviewDetailsWrapper: React.FC<InterviewDetailsWrapperProps> = ({
  ...props
}) => {
  const { callId } = useParams() as { callId: string };

  const { loading, error, data } = useCallTypeQuery({
    variables: { id: callId },
  });

  // Checks if the call has been deleted
  const [auditLogItemExists, { data: auditData, loading: auditLoading }] =
    useAuditLogItemExistsLazyQuery({
      variables: {
        id: callId,
        name: "redact_interview",
        property: "interview_id", // interview_id is correct
      },
    });

  const call = data?.call;

  if (loading || auditLoading) {
    return <LoadingIndicator pt="10vh" />;
  }

  if (error || !call) {
    let errorView = "error";

    if (error?.graphQLErrors.some((e) => e.extensions?.code === "FORBIDDEN")) {
      errorView = "forbidden";
    }

    if (
      error?.graphQLErrors.some((e) => e.extensions?.code === "NOT_FOUND") ||
      (!error && !call)
    ) {
      if (auditData === undefined) {
        auditLogItemExists();
        return null;
      }

      if (auditData?.auditLogItemExists) {
        errorView = "deleted";
      } else {
        errorView = "none";
      }
    }

    return (
      <Flex flexDirection="column" overflowY="hidden">
        <CallErrorState view={errorView} />
      </Flex>
    );
  }

  if (call.type === CallType.AiInterview) {
    return <AiInterviewDetails callId={call.id} {...props} />;
  }

  return <InterviewDetails callId={call.id} {...props} />;
};

export default InterviewDetailsWrapper;
